export default __webpack_public_path__ + "static/media/map.3a57e88c.png";